import { render, staticRenderFns } from "./spam_settings.vue?vue&type=template&id=3b5fa878&"
import script from "./spam_settings.vue?vue&type=script&lang=js&"
export * from "./spam_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports